import { useState } from "react";
import BuscadorContacto from "../contactos/BuscadorContacto";
import { usePropiedadUi } from "../../hooks/usePropiedadUi";

/**
 * Buscador de propietario + botón crear, con texto de búsqueda disponible al abrir el modal.
 */
export default function PropietarioBuscarOCrear({
  onSeleccionar,
  onAbrirCrear,
  isDark,
  compact = false,
  placeholder = "Nombre, teléfono o email...",
  initialValue = "",
  buscadorProps = {},
  mostrarEtiquetaBuscar = true,
  mostrarSeparador = true,
  puedeVerBuscarExistente = true,
  puedeVerCrearNuevo = true,
}) {
  const { tv } = usePropiedadUi();
  const [texto, setTexto] = useState(initialValue);

  const sepSt = {
    fontSize: 11,
    color: isDark ? "#6b7280" : "#9ca3af",
    margin: compact ? "4px 0 2px" : "8px 0 6px",
  };

  return (
    <>
      {puedeVerBuscarExistente && (
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: compact ? 4 : 8 }}>
        {mostrarEtiquetaBuscar && (
          <span style={{ fontSize: 12, color: isDark ? "#9ca3af" : "#6b7280", whiteSpace: "nowrap" }}>
            {tv("Buscar existente:")}
          </span>
        )}
        <BuscadorContacto
          onSeleccionar={onSeleccionar}
          onTextChange={setTexto}
          initialValue={initialValue}
          isDark={isDark}
          compact={compact}
          placeholder={placeholder}
          {...buscadorProps}
        />
      </div>
      )}
      {puedeVerCrearNuevo && (
      <div style={{ display: "flex", alignItems: "center", gap: compact ? 8 : 12, marginTop: compact ? 2 : 4, flexWrap: "wrap" }}>
        {mostrarSeparador && <span style={sepSt}>{tv("— o crear nuevo propietario —")}</span>}
        <button
          type="button"
          onClick={() => onAbrirCrear(texto)}
          style={{
            padding: compact ? "4px 10px" : "8px 18px",
            background: "#2563eb",
            color: "#fff",
            border: "none",
            borderRadius: compact ? 6 : 8,
            fontSize: compact ? 11 : 13,
            fontWeight: 600,
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          + {tv("Crear propietario")}
        </button>
      </div>
      )}
    </>
  );
}
